 document.addEventListener('DOMContentLoaded', () => {
    const openBtn = document.getElementById('one-time-payment-button');
    const panel = document.getElementById('slideUpPanel');
    const closeBtn = document.getElementById('closePanelBtn');
    onChangeCheckBoxes();  
    onChangeSelectOption();
    onClickNoThanks();
    AddRecommendedToCart();

    openBtn.addEventListener('click', (event) => {
      if (window.ScanCenterCart && !window.ScanCenterCart.validate()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      if (window.ScanCenterCart) {
        window.ScanCenterCart.updateCartPropertyFields();
      }

      event.preventDefault(); // Prevent default behavior
      const product = getMainProduct();
      addMainProdct(product);
          autoCheckRecommendedFromCart(); 
updateCart();
updateTotalPrice();
      panel.classList.add('active');
    });

    closeBtn.addEventListener('click', () => {
      panel.classList.remove('active');
    });
    
  });

// function AddRecommendedToCart(){
//   const form = document.getElementById('recomProductForm');
//   var cartProducts = getCartItems();
//   form.addEventListener('submit', function(e) {
//     e.preventDefault();

//     const mainProductId = document.querySelector('[name="main-product"]').dataset.productId;
//     const selectedAddons = Array.from(document.querySelectorAll('.add-on-checkbox:checked:not(.no-product)'))
//       .map(cb => ({
//         id: cb.getAttribute('data-product-id'),
//         quantity: parseInt(cb.getAttribute('data-quantity') || 1, 10)
//       }));

//     const items = [{ id: mainProductId, quantity: 1 }, ...selectedAddons];

//     fetch('/cart/add.js', {
//       method: 'POST',
//       headers: {'Content-Type': 'application/json'},
//       body: JSON.stringify({ items })
//     })
//     .then(res => res.json())
//     .then(() => fetch('/cart.js'))
//     .then(res => res.json())
//     .then(cart => {
//       //renderDrawer(cart); // Update your drawer content
//       //document.getElementById('custom-cart-drawer').classList.add('open');
//       window.location.href = "https://caspersmile.uk/checkout"
//     })
//     .catch(err => console.error('Add to Cart Error:', err));
//   });
// }



function getCartProductIds() {
  return fetch('/cart.js')
    .then(res => res.json())
    .then(cart => cart.items.map(item => item.id.toString()))
    .catch(err => {
      console.error("Cart fetch error:", err);
      return [];
    });
}

function AddRecommendedToCart() {
  const form = document.getElementById('recomProductForm');

  form.addEventListener('submit', function(e) {
    e.preventDefault();

    const mainProductId = document.querySelector('[name="main-product"]').dataset.productId;

    const selectedAddons = Array.from(
      document.querySelectorAll('.add-on-checkbox:checked:not(.no-product)')
    ).map(cb => ({
      id: cb.getAttribute('data-product-id'),
      quantity: parseInt(cb.getAttribute('data-quantity') || '1', 10)
    }));

    getCartProductIds().then(cartIds => {
      const filteredAddons = selectedAddons.filter(addon =>
        !cartIds.includes(addon.id)
      );

      const scanCenterProperties = window.ScanCenterCart
        ? window.ScanCenterCart.getLineItemProperties()
        : {};

      const mainItem = {
        id: mainProductId,
        quantity: 1
      };

      if (scanCenterProperties && Object.keys(scanCenterProperties).length > 0) {
        mainItem.properties = scanCenterProperties;
      }

      const itemsToAdd = [
        mainItem,
        ...filteredAddons
      ];

      const addToCart = itemsToAdd.length > 0
        ? fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: itemsToAdd })
          }).then(res => res.json())
        : Promise.resolve();

      addToCart
        .then(() => {
          if (window.ScanCenterCart) {
            return window.ScanCenterCart.updateCartAttributes();
          }
        })
        .then(() => fetch('/cart.js'))
        .then(res => res.json())
        .then(cart => {
          window.location.href = "https://caspersmile.uk/checkout";
        })
        .catch(err => console.error('Add to Cart Error:', err));
    });
  });
}


function autoCheckRecommendedFromCart() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const cartProductIds = cart.items.map(item => item.id.toString());

      document.querySelectorAll('.add-on-checkbox:not(.no-product)').forEach(cb => {
        const productId = cb.getAttribute('data-product-id')?.toString().trim();

        if (productId && cartProductIds.includes(productId)) {
          cb.checked = true;
          cb.setAttribute("data-already-in-cart", "true"); 
        } 
      });
    })
    .catch(err => console.error("Cart fetch error:", err));
    
}




function onChangeSelectOption() {  
    const allSelect = document.querySelectorAll('.extra-variants');        

    // Update checkbox attributes and price display on select change
    allSelect.forEach(select =>{ 
      const productContainer  = select.closest(".recommended-product");
      const priceContainer    = productContainer.querySelector('.price h4');  
      const checkbox          = productContainer.querySelector('.add-on-checkbox');    
    
      select.addEventListener('change', (event) => {
      const selectedOption = event.target.selectedOptions[0];
    
      const newProductId = selectedOption.value;
      const newPrice = selectedOption.getAttribute('data-price').replace(/[£]/g, '');
      const comparePrice = selectedOption.getAttribute('data-compare-price');

      // Update checkbox attributes
      checkbox.setAttribute('data-product-id', newProductId);
      checkbox.setAttribute('data-product-price', newPrice);
      checkbox.checked = true;
      // Update visible price
      priceContainer.innerHTML = `£${newPrice} <span class="previous-price">(${comparePrice})</span>`;
      updateCart();
      updateTotalPrice();
      unCheckNoProduct();
    });
  });
}

function onChangeCheckBoxes(){
    const allCheckBoxes = document.querySelectorAll('.add-on-checkbox:not(.no-product)');
    allCheckBoxes.forEach(cb=> { 
      cb.addEventListener('change', (event)=>{      
      updateCart();
      updateTotalPrice();
      unCheckNoProduct();  
    });
  });
}

function unCheckNoProduct(){
  let noThanks = document.querySelector("input.no-product");
  noThanks.checked = false;  
}



function updateTotalPrice(){
      const allCheckboxes = document.querySelectorAll('.add-on-checkbox');
      const totalPriceDisplay = document.querySelector('.cart-total .total.price');
      const mainProductPrice = document.querySelector('[name="main-product"]');
      
      let total = parseFloat(mainProductPrice.getAttribute('data-product-price') || '0');;

      allCheckboxes.forEach(cb => {
        if (cb.checked) {
          const price = parseFloat(cb.getAttribute('data-product-price') || '0');
          total += price;         
        }
      });

      total = total.toFixed(2);
      
      totalPriceDisplay.textContent = `£${total}`;
}
function updateCart(){
      const allCheckboxes = document.querySelectorAll('.add-on-checkbox');
      const totalPriceDisplay = document.querySelector('.cart-total .total.price');
      const mainProductPrice = document.querySelector('[name="main-product"]');      
      let total = parseFloat(mainProductPrice.getAttribute('data-product-price') || '0');
      allCheckboxes.forEach(cb => {
        if (cb.checked) {
          const price = parseFloat(cb.getAttribute('data-product-price') || '0');
          total += price;
        }
      });
      total = total.toFixed(2);
      totalPriceDisplay.textContent = `£${total}`;
}
function addMainProdct(product){
  const mainProductPrice = document.querySelector('[name="main-product"]');
  mainProductPrice.setAttribute("value",product.id);
  mainProductPrice.setAttribute("data-product-id",product.id);
  mainProductPrice.setAttribute("data-product-price",product.price);
  mainProductPrice.setAttribute("data-product-compare-price",product.compare_price);
}
function getMainProduct(){
  const oneTimeBtn          = document.getElementById("one-time-payment-button");

    const oneTimeForm         = oneTimeBtn.closest("form");
    const selectedProductIds  = oneTimeForm.querySelectorAll("[name='id']");
    const totalIds            = selectedProductIds.length;
    const lastIndex           = totalIds-1;
    const selectedProductId   = selectedProductIds[lastIndex];
    const inputType           = selectedProductId.localName;
    let productId           = null;
    const product             = {id:null, price: null, compare_price: null}
    
    if(inputType == "select"){
      const selectedOption = selectedProductId.selectedIndex;
      productId     = selectedProductId[selectedOption];      
      product.id    = productId.value;
      product.price = productId.getAttribute("data-var-price").replace(/[£]/g, '').replace(/[GBP]/g, '').replace(/[' ']/g, '');
      
    }else{
      productId     = selectedProductId;
      product.id    = productId.value;
      product.price = productId.getAttribute("data-var-price").replace(/[£]/g, '').replace(/[GBP]/g, '').replace(/[' ']/g, '');
    }
    return product;
}



document.addEventListener('DOMContentLoaded', () => {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const cartProductIds = cart.items.map(item => item.id.toString());

      document.querySelectorAll('.add-on-checkbox').forEach(cb => {
        const productId = cb.getAttribute('data-product-id');
        
        if (productId && cartProductIds.includes(productId)) {
          cb.checked = true;
          cb.setAttribute("data-already-in-cart", "true");
        } else {
          cb.checked = false;
        }
      });
    })
    .catch(err => console.error("Cart fetch error:", err));
});







function onClickNoThanks() {
  const noThanks = document.querySelector("input.no-product");
  noThanks.addEventListener("change", event => {
    if (!event.target.checked) return;

    const selectedAddons = Array.from(
      document.querySelectorAll('.add-on-checkbox:checked:not(.no-product)')
    ).map(cb => ({
      id: cb.getAttribute('data-product-id').toString(),
      element: cb
    }));

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        var updates = {};
        cart.items.forEach(item => {
          const matchedAddon = selectedAddons.find(
            addon => addon.id === item.variant_id.toString()
          );
          if (matchedAddon) {
            updates[item.variant_id] = 0; // ✅ use variant_id
            matchedAddon.element.checked = false; // ✅ uncheck checkbox
          }
        });

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
      })
      .then(() => {
        updateCart();
        updateTotalPrice();
      })
      .catch(err => console.error('Error in No Thanks flow:', err));
  });
}
